import * as ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategory from './media-enterprise-public-media-v1-enterprise-category-enterprise-media-categories.http.js';
import * as ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryTypes from './media-enterprise-public-media-v1-enterprise-category-enterprise-media-categories.types.js';
import * as ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryUniversalTypes from './media-enterprise-public-media-v1-enterprise-category-enterprise-media-categories.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createCategory(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryUniversalTypes.CreateCategoryRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryTypes.CreateCategoryRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryUniversalTypes.CreateCategoryResponse,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryTypes.CreateCategoryResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategory.createCategory(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/enterprise/categories',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteCategory(): __PublicMethodMetaInfo<
  'DELETE',
  { categoryId: string },
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryUniversalTypes.DeleteCategoryRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryTypes.DeleteCategoryRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryUniversalTypes.DeleteCategoryResponse,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryTypes.DeleteCategoryResponse
> {
  const payload = { categoryId: ':categoryId' } as any;

  const getRequestOptions =
    ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategory.deleteCategory(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/enterprise/categories/{categoryId}',
    pathParams: { categoryId: 'categoryId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateCategory(): __PublicMethodMetaInfo<
  'PATCH',
  { categoryId: string },
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryUniversalTypes.UpdateCategoryRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryTypes.UpdateCategoryRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryUniversalTypes.UpdateCategoryResponse,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryTypes.UpdateCategoryResponse
> {
  const payload = { category: { id: ':categoryId' } } as any;

  const getRequestOptions =
    ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategory.updateCategory(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/enterprise/categories/{category.id}',
    pathParams: { categoryId: 'categoryId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getCategory(): __PublicMethodMetaInfo<
  'GET',
  { categoryId: string },
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryUniversalTypes.GetCategoryRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryTypes.GetCategoryRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryUniversalTypes.GetCategoryResponse,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryTypes.GetCategoryResponse
> {
  const payload = { categoryId: ':categoryId' } as any;

  const getRequestOptions =
    ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategory.getCategory(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/enterprise/categories/{categoryId}',
    pathParams: { categoryId: 'categoryId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function enterpriseOnboarding(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryUniversalTypes.EnterpriseOnboardingRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryTypes.EnterpriseOnboardingRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryUniversalTypes.EnterpriseOnboardingResponse,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryTypes.EnterpriseOnboardingResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategory.enterpriseOnboarding(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/enterprise/onboarding',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getMediaManagerCategories(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryUniversalTypes.GetMediaManagerCategoriesRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryTypes.GetMediaManagerCategoriesRequest,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryUniversalTypes.GetMediaManagerCategoriesResponse,
  ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategoryTypes.GetMediaManagerCategoriesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMediaEnterprisePublicMediaV1EnterpriseCategory.getMediaManagerCategories(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/enterprise/media-manager/categories',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  EnterpriseCategory as EnterpriseCategoryOriginal,
  PublishStatus as PublishStatusOriginal,
  PublishStatusWithLiterals as PublishStatusWithLiteralsOriginal,
  MediaType as MediaTypeOriginal,
  MediaTypeWithLiterals as MediaTypeWithLiteralsOriginal,
  CreateCategoryRequest as CreateCategoryRequestOriginal,
  CreateCategoryResponse as CreateCategoryResponseOriginal,
  DeleteCategoryRequest as DeleteCategoryRequestOriginal,
  DeleteCategoryResponse as DeleteCategoryResponseOriginal,
  UpdateCategoryRequest as UpdateCategoryRequestOriginal,
  UpdateCategoryResponse as UpdateCategoryResponseOriginal,
  GetCategoryRequest as GetCategoryRequestOriginal,
  GetCategoryResponse as GetCategoryResponseOriginal,
  EnterpriseCategoryTree as EnterpriseCategoryTreeOriginal,
  EnterpriseOnboardingRequest as EnterpriseOnboardingRequestOriginal,
  EnterpriseOnboardingResponse as EnterpriseOnboardingResponseOriginal,
  LinkItemsToCategoryRequest as LinkItemsToCategoryRequestOriginal,
  LinkItemsToCategoryResponse as LinkItemsToCategoryResponseOriginal,
  UnlinkItemsFromCategoryRequest as UnlinkItemsFromCategoryRequestOriginal,
  UnlinkItemsFromCategoryResponse as UnlinkItemsFromCategoryResponseOriginal,
  GetMediaManagerCategoriesRequest as GetMediaManagerCategoriesRequestOriginal,
  GetMediaManagerCategoriesResponse as GetMediaManagerCategoriesResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './media-enterprise-public-media-v1-enterprise-category-enterprise-media-categories.types.js';
